/**
 * Validate a non-cash option replacement pair already produced by replay and return its quantity factor: a whole
 * forward split (factor > 1) or a verified OCC root rename (factor 1, same quantity under the successor contract).
 */
export function getOptionSplitMultiplier(out, incoming) {
    const factor = Number(incoming.quantity) / Number(out.quantity);
    if (out.type !== 'splitOut' ||
        incoming.type !== 'splitIn' ||
        out.timestamp !== incoming.timestamp ||
        out.legId !== incoming.legId ||
        out.entityId !== incoming.entityId ||
        out.entityType !== incoming.entityType ||
        out.derivativeId === incoming.derivativeId ||
        !Number.isInteger(factor) ||
        factor < 1 ||
        [out, incoming].some((row) => row.derivativeType !== 'Option' ||
            row.derivativeId == null ||
            !Number.isFinite(Number(row.quantity)) ||
            Number(row.quantity) <= 0 ||
            !Number.isSafeInteger(Number(row.quantity)) ||
            row.contractMultiplier !== 100 ||
            Number(row.price) !== 0 ||
            Number(row.value) !== 0 ||
            Number(row.fees) !== 0 ||
            Number(row.riskCapital) !== 0)) {
        throw new Error('Invalid non-cash option replacement');
    }
    return factor;
}
//# sourceMappingURL=getOptionSplitMultiplier.js.map